// @flow
import { PRODUCT_STREET_VIEW } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_STREET_VIEW } from 'Utils/request/requestDictionary';

type CMSProps = {|
  resortId: string,
|};

export const productGoogleStreetViewResolver = {
  name: PRODUCT_STREET_VIEW,
  resolve: (appContext: AppContext, props: CMSProps) => {
    const query = `query {
      config {
        common { close }
      }
      resort(resortId: "${props.resortId}") {
        name
        streetView {
          latitude
          longitude
          heading
          pitch
          fov
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_STREET_VIEW,
      strictErrors: false,
    });
  },
};
